import script from "./kf_drawer_popup.vue?vue&type=script&setup=true&lang=js"
export * from "./kf_drawer_popup.vue?vue&type=script&setup=true&lang=js"

import "./kf_drawer_popup.vue?vue&type=style&index=0&id=6b007621&lang=scss"
import "./kf_drawer_popup.vue?vue&type=style&index=1&id=6b007621&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b007621"]])

export default __exports__